import React from 'react';

const TickIcon = () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
        d="M7 13.1435L10.0579 16L17 9"
        stroke="#4D8848"
        strokeLinecap="round"
        strokeLinejoin="round"/>
    </svg>
);
    

export default TickIcon;




// WEBPACK FOOTER //
// ./src/components/Icons/TickIcon.js